import React from 'react';
import { StrapiContentRenderer } from '../../components';
import css from './SeoCategoryPage.module.css';

function RenderParagraphs(props) {
  const { content } = props;
  const image = content?.image?.url;
  const headingImage = image?.includes('amazon')
    ? image
    : `${process.env.REACT_APP_STRAPI_BASE_URL}${image}`;

  return (
    <>
      {content?.title ? <h3>{content?.title}</h3> : null}
      <div className={css.contentImgWrapper}>
        {image ? (
          <div className={css.contentImg}>
            <img src={headingImage} alt={content?.heading} />
          </div>
        ) : null}
      </div>
      <p>
        {content?.description ? <StrapiContentRenderer content={content?.description} /> : null}
      </p>
    </>
  );
}

export default RenderParagraphs;
